import { fetchPageData } from "../utils/fetch";

export const getSdgsProjects = async () => {
  const endpoint = "sdgsProjects";
  const method = "GET";
  const err = "Failed to fetch sdgsProjects.";
  const fetchedData = await fetchPageData(endpoint, method, err);
  return fetchedData;
};

export const updateSdgsProject = async (
  token,
  sdgsProjectId,
  sdgsProjectData
) => {
  const endpoint = sdgsProjectId
    ? `sdgsProject/${sdgsProjectId}`
    : "sdgsProject";
  const err = sdgsProjectId
    ? "Editing project failed."
    : "Creating project failed.";
  const method = sdgsProjectId ? "PUT" : "POST";
  const fetchedData = await fetchPageData(
    endpoint,
    method,
    err,
    token,
    sdgsProjectData
  );
  return fetchedData;
};

export const deleteSdgsProject = async (token, sdgsProjectId) => {
  const endpoint = `sdgsProject/${sdgsProjectId}`;
  const method = "DELETE";
  const err = "Deleting sdgsProject failed.";
  const fetchedData = await fetchPageData(endpoint, method, err, token);
  return fetchedData;
};
